import React from "react";
import { object, func, string } from "prop-types";
import { Link } from "@quintype/components";

import "./show-more-button.m.css";
import { generateNavigateSlug } from "../../utils";
import { SvgIconHandler } from "../svg-icon-hadler";

const ShowMoreButton = ({
  config = {},
  collection,
  navigate,
  qtConfig,
  customStyleName = "",
  isRecipePage = false,
}) => {
  const { customUrlPath = "" } = config;
  const UrlPath = collection?.metadata?.["collection-display-url"] || "";
  const slug = UrlPath
    ? UrlPath
    : customUrlPath
    ? `/${customUrlPath}`
    : generateNavigateSlug(collection, { ...qtConfig, ...config });
  let collectionDisplayName = collection?.metadata?.["collection-display-name"] || collection?.name;

  return (
    <>
      {!isRecipePage ? (
        <Link
          href={slug}
          navigateTo={navigate}
          data-test-id="more-stories"
          styleName={`more-stories ${customStyleName}`}
        >
          <p>MORE STORIES</p>
          <span styleName="icon-color">
            <SvgIconHandler type="arrow-circle-right" width="24px" height="24px" viewBox="0 0 24 24" />
          </span>
        </Link>
      ) : (
        <Link href={slug} navigateTo={navigate} data-test-id="more-stories" styleName={`recipe-page-more-stories`}>
          <p>See More {collectionDisplayName}</p>
        </Link>
      )}
    </>
  );
};

ShowMoreButton.propTypes = {
  config: object,
  collection: object,
  navigate: func,
  qtConfig: object,
  customStyleName: string,
};

export default ShowMoreButton;
